/**
 * Decide whether a 401/403 response means the session is invalid (logout) vs a
 * permission or transient failure (keep session).
 */
export function isDefinitiveAuthFailure(
  status: number | undefined,
  errorData: unknown,
): boolean {
  if (status !== 401 && status !== 403) return false;

  const payload =
    errorData && typeof errorData === 'object'
      ? (errorData as { error?: unknown; message?: unknown; code?: unknown })
      : {};
  const errorField = String(payload.error ?? '').toLowerCase();
  const messageField = String(payload.message ?? '').toLowerCase();
  const codeField = String(payload.code ?? '').toLowerCase();
  const combined = `${errorField} ${messageField} ${codeField}`.trim();

  if (isOwnershipOrPermissionFailure(messageField, errorField, status)) {
    return false;
  }

  if (
    errorField.includes('invalid credentials') ||
    errorField.includes('invalid token') ||
    errorField.includes('no credentials') ||
    combined.includes('no credentials sent') ||
    combined.includes('invalid credentials sent')
  ) {
    return true;
  }

  if (
    combined.includes('token has expired') ||
    combined.includes('incoming token has expired') ||
    combined.includes('expired token') ||
    combined.includes('jwt expired') ||
    combined.includes('signature') ||
    combined.includes('missing authorization')
  ) {
    return true;
  }

  if (status === 401 && combined.includes('unauthorized') && !combined.includes('permission')) {
    return true;
  }

  return false;
}

function isOwnershipOrPermissionFailure(
  messageField: string,
  errorField: string,
  status: number,
): boolean {
  if (messageField.includes('cannot update another user')) return true;
  if (messageField.includes("don't have permission") || messageField.includes('do not have permission')) {
    return true;
  }
  if (errorField === 'account banned' || errorField === 'account deleted') {
    return true;
  }
  if (status === 403 && messageField.includes('unauthorized')) {
    return true;
  }
  return false;
}
